import { Component, ViewContainerRef, OnInit, ViewChild, ElementRef, AfterViewInit, Input, OnDestroy, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from '../../_services/dialog.service';
import { HttpClient } from '@angular/common/http';
import { UserService } from '../../_services/user.service';
import { Venue } from '../../_models/Venue';
import { VenueSection, Point } from '../../_models/VenueSection';
import { VenueService } from '../../_services/venue.service';
import { map, mergeMap } from 'rxjs/operators';
import { Subject, of } from 'rxjs';
import { PhotoService } from '../../_services/photo.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { VenueSectionInputModalComponent } from './venue-section-input.component';
import {Validators} from "@angular/forms";

@Component({
  selector: 'app-venue-form',
  templateUrl: './venue-form.component.html',
  styleUrls: ['./venue-form.component.css']
})

export class VenueFormComponent implements OnInit, OnDestroy, AfterViewInit  {

  venue: Venue;
  venueName = '';
  id = -1;
  newSectionName = '';

  newGroupName = '';
  selectedGroup = '';
  selectedSection: VenueSection = null;
  searchText = '';

  loading = false;
  mouseDrag = false;
  mouseX = 0;
  mouseY = 0;

  private _wordLimitation = 30;
  public isGroupNameError = false;
  public isNameError = false;
  public isImageError = false;
  private _ngDestroy$ = new Subject<void>();

  private bsModalRef: BsModalRef;

  opacity = 50;

  // sectionHistory: VenueSection[] = [];

  multiSelectStart: Point = { x: -1, y: -1 };

  selectedTool = '';

  private removeEventListeners: any[] = [];

  public validImageType = true;

  @ViewChild('venueRef', { static: false })
  private venueRef: ElementRef;

  @ViewChild('sectionsRef', { static: false })
  private sectionsRef: ElementRef;

  constructor(
    private venueService: VenueService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private viewRef: ViewContainerRef,
    private httpClient: HttpClient,
    private imageService: PhotoService,
    private renderer: Renderer2,
    userService: UserService,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService
  ) {

  }

  checkNameValidity(){
    this.isNameError = !this.venueName.length
  }
  ngOnInit() {
    this.loading = true;
    this.spinner.show();
    this.route.params
    .pipe(mergeMap(params => {
      this.id = params['id'];
      if (this.id > 0) {
        return this.venueService.getById(this.id);
      } else {
        return of({
          venueId: this.id,
          name: '',
          imageUrl: '',
          active: false,
          venueSections: [],
          venueGroups: []
        } as Venue);
      }
    }))
    .subscribe(
      data => {
        data.venueGroups = [];
        this.venueName = data.name;
        if (data.venueSections) {
          data.venueSections.sort((a, b) => a.name.localeCompare(b.name));
          data.venueSections.map(s => {
            s.selected = false;
            data.venueGroups.push(...s.groups);
          });
          data.venueGroups = Array.from(new Set(data.venueGroups)).filter(g => g !== '')
            .sort((a, b) => a.localeCompare(b));
        }

        this.venue = data;
        this.loading = false;
        this.spinner.hide();
      },
      err => {
        // unable to load
        this.loading = false;
        this.spinner.hide();
      }
    );
  }

  changeSectionName() {
    this.newSectionName = this.newSectionName.slice(0, this._wordLimitation)
  }

  changeGroupName() {
    this.isGroupNameError = this.newGroupName.length > this._wordLimitation || !this.newGroupName
  }

  ngAfterViewInit() {
    this._attachEventListeners();
  }

  loadCanvas() {
    if (!this.venueRef) {
      return;
    }

    const canvas = this.venueRef.nativeElement;
    const rect = canvas.getBoundingClientRect();

    // scale the canvas to 2x the size of the image
    canvas.width = rect.width * 2;
    canvas.height = rect.height * 2;

    this.updateCanvas();
  }

  selectSection(section: VenueSection) {

    const sectionIndex = this.venue.venueSections.indexOf(section);
    this.selectedSection = null;

    // if no group is selected, only allow one section to be selected at a time
    // else add or remove the selected section from the selected group
    if (this.selectedGroup === '') {

      for (let n = 0; n < this.venue.venueSections.length; ++n) {

        if (n === sectionIndex) {

          section.selected = !section.selected;
          if (section.selected) {

            this.selectedSection = section;
          }

        } else {

          this.venue.venueSections[n].selected = false;
        }
      }

    } else {

      section.selected = !section.selected;

      if (section.selected) {

        section.groups.push(this.selectedGroup);
        this.selectedSection = section;

      } else {

        const i = section.groups.indexOf(this.selectedGroup);
        if (i >= 0) {

          section.groups.splice(i, 1);
        }
      }
    }

    // only allow tools to be active if one section is selected, and set the active tool
    //
    if (this.singleSelection()) {
      if (section.shapeType !== '') {
        section.shapeType = section.shapeType;
      }
    } else {
      this.selectedTool = '';
    }

    this.updateCanvas();
  }

  selectGroup(group: string) {
    if (this.selectedGroup === group) {
      this.selectedGroup = '';
      this.venue.venueSections.map(s => s.selected = false);
    } else {
      this.selectedGroup = group;

      this.venue.venueSections.forEach(s => {
        s.selected = false;
        if (s.groups.indexOf(group) >= 0) {
          s.selected = true;
        }
      });
    }
    this.updateCanvas();
  }

  createNewSection() {
    if (this.newSectionName === null || this.newSectionName.match(/^ *$/) !== null) {
      return;
    }
    this.venue.venueSections
    .filter(s => s.groups.indexOf(this.selectedGroup) < 0)
    .map(s => s.selected = false);

    const sectionList = this.venue.venueSections.filter(s => s.name === this.newSectionName);
    if (sectionList.length < 1) {
      const newSection: any = {
        selected: true,
        name: this.newSectionName,
        groups: this.selectedGroup !== '' ? [this.selectedGroup] : [],
        shapeType: '',
        shapeData: []
      };

      this.selectedSection = newSection;
      this.venue.venueSections.push(newSection);
      this.updateCanvas();
    } else {
      this.selectSection(sectionList[0]);
    }

    this.newSectionName = '';

    this.venue.venueSections.sort((a, b) => a.name.localeCompare(b.name));
  }

  createNewGroup() {
    if (this.newGroupName === null || this.newGroupName.match(/^ *$/) !== null) {
      this.isGroupNameError = true;
      return;
    }
    if (this.venue.venueGroups.indexOf(this.newGroupName) < 0) {
      this.venue.venueGroups.push(this.newGroupName);
      this.venue.venueSections.filter(s => s.selected).map(s => s.groups.push(this.newGroupName));
    }
    this.selectGroup(this.newGroupName);
    this.newGroupName = '';
    this.venue.venueGroups.sort((a, b) => a.localeCompare(b));
  }

  uploadPng(file: File) {

    const correctFileType = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg';

    if (file && correctFileType) {

      this.validImageType = true;

      this.imageService.enqueueUploadPhoto(file, 'venue-image', { height: 1200, width: 1200 }, false, false)
      .subscribe(res => {
        this.isImageError = false;
        this.venue.imageUrl = res.url;
      });

    } else {

      this.validImageType = false;
    }
  }

public singleSelection(): boolean {
  if (this.venue && this.venue.venueSections) {
    const selectedSections = this.venue.venueSections.filter(s => s.selected);
    return selectedSections && selectedSections.length === 1;
  }
  return false;
}

public toolDisabled(toolName: string): boolean {
  if (this.venue && this.venue.venueSections) {
    const selectedSections = this.venue.venueSections.filter(s => s.selected);
    if (selectedSections && selectedSections.length === 1) {
      if (selectedSections[0].shapeType === '') {
        return false;
      }
      return selectedSections[0].shapeType !== toolName;
    }
  }
  return true;
}

public deleteShape() {
  const selectedSections = this.venue.venueSections.filter(s => s.selected);
  if (selectedSections.length === 0) {
    return;
  }
  if (!this.singleSelection()) {
    this.dialogService
      .confirm(
        'Confirm Multi Delete',
        'Are you sure you want to delete the shapes in all selected sections?',
        this.viewRef)
        .then(result => {
          if (result) {
            this.venue.venueSections
              .filter(s => s.selected)
              .forEach(s => {
                s.shapeData.length = 0;
                s.shapeType = '';
              });
              this.updateCanvas();
          }
        });
  } else {
    this.venue.venueSections.filter(s => s.selected)[0].shapeData.length = 0;
    this.venue.venueSections.filter(s => s.selected)[0].shapeType = '';
    this.updateCanvas();
  }
}

  public mouseEvent(e: MouseEvent) {
    const canvas = this.venueRef.nativeElement;
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    this.mouseX = (e.clientX - rect.left) * scaleX;
    this.mouseY = (e.clientY - rect.top) * scaleY;

    const selectedSections = this.venue.venueSections.filter(s => s.selected);

    if (e.type === 'mouseup') {
      switch (this.selectedTool) {
        case('multiselect'):
          this.venue.venueSections.forEach(s => {
            if (s.shapeData.filter(p => {
              return p.x >= this.multiSelectStart.x
              && p.x <= this.mouseX
              && p.y >= this.multiSelectStart.y
              && p.y <= this.mouseY;
            }).length > 0) {
              s.selected = true;
            }
          });
          break;
        case('polygon'):
        case('rectangle'):
        case('circle'):
          if (selectedSections.length === 1) {
            this.addPointToSectionShape(selectedSections[0]);
          }
        break;
      }

      this.mouseDrag = false;
    } else if (e.type === 'mousedown') {
      switch (this.selectedTool) {
        case('multiselect'):
          this.multiSelectStart.x = this.mouseX;
          this.multiSelectStart.y = this.mouseY;
          break;
        case('polygon'):
        case('rectangle'):
        case('circle'):
          if (selectedSections.length === 1 && selectedSections[0].shapeData.length === 0) {
            this.addPointToSectionShape(selectedSections[0]);
          }
        break;
      }

      this.mouseDrag = true;
    }

    this.updateCanvas();
}

  addPointToSectionShape(selectedSection: VenueSection) {
    const selctionIndex = this.venue.venueSections.indexOf(selectedSection);
      if (selctionIndex > -1) {
        this.venue.venueSections[selctionIndex].shapeType = this.selectedTool;
        this.venue.venueSections[selctionIndex].shapeData
          .push({x: this.mouseX, y: this.mouseY });
      }
  }

  public undoDraw() {
    const selectedSections = this.venue.venueSections.filter(s => s.selected);

    if (selectedSections && selectedSections.length === 1) {
      const selectedSection = selectedSections[0];
      const selectedIndex = this.venue.venueSections.indexOf(selectedSection);

      if (this.venue.venueSections[selectedIndex].shapeData.length > 0) {
        this.venue.venueSections[selectedIndex].shapeData.pop();
        this.updateCanvas();
      }
    }
  }

  deleteSelectedGroup() {
    if (this.selectedGroup !== '') {
      this.venue.venueGroups.splice(this.venue.venueGroups.indexOf(this.selectedGroup), 1);
      this.venue.venueSections.forEach(s => {
        s.groups = s.groups.filter(g => g !== this.selectedGroup);
        s.selected = false;
      });
      this.selectedGroup = '';
    }
  }

  deleteSelectedSections() {
    const selectedSections = this.venue.venueSections.filter(s => s.selected);

    if (selectedSections.length > 1) {
      this.dialogService
      .confirm(
        'Confirm Multi Delete',
        'Are you sure you want to delete all of the selected sections and their shapes?',
        this.viewRef)
        .then(result => {
          if (result) {
            this.venue.venueSections = this.venue.venueSections.filter(s => !s.selected);
            this.updateCanvas();
          }
        });
    } else {
      this.venue.venueSections = this.venue.venueSections.filter(s => !s.selected);
      this.updateCanvas();
    }
  }

  private distance(a: Point, b: Point) {
    return Math.hypot(b.x - a.x, b.y - a.y);
  }

  public updateCanvas() {
    if (!this.venueRef) {
      return;
    }
    const canvas = this.venueRef.nativeElement;
    const ctx = canvas.getContext('2d');

    const w = canvas.width;
    const h = canvas.height;

    let scaleAdj = 1;
    if (this.venue.canvasWidth > 0) {
      scaleAdj =  w / this.venue.canvasWidth;
    }

    ctx.clearRect(0, 0, w, h);

    this.venue.venueSections.forEach(s => {

        const region = new Path2D();
        ctx.beginPath();

        if (s.selected) {
          ctx.lineWidth = 5;
          ctx.strokeStyle = '#00ff00';
          ctx.fillStyle = '#00ff00';
        } else {
          ctx.lineWidth = 1;
          ctx.strokeStyle = '#000000';
          ctx.fillStyle = 'black';
        }

        const sd = s.shapeData;
        switch (s.shapeType) {
          case('polygon'):
            sd.forEach(p => {
                ctx.lineTo(p.x * scaleAdj, p.y * scaleAdj);
            });
          break;
          case('rectangle'):
            if (sd.length >= 2) {
              sd.length = 2;
              ctx.rect(sd[0].x * scaleAdj, sd[0].y * scaleAdj, (sd[1].x - sd[0].x) * scaleAdj, (sd[1].y - sd[0].y) * scaleAdj);
            }
          break;
          case('circle'):
            if (sd.length >= 2) {
              sd.length = 2;
              const r = (sd[1].x - sd[0].x) / 2;
              const cx = sd[0].x + r;
              const cy = sd[0].y + r;
              ctx.arc(cx * scaleAdj, cy * scaleAdj, r * scaleAdj, 0, 2 * Math.PI);
            }
          break;
        }

        if (this.mouseDrag) {
          if (s.selected) {
            switch (this.selectedTool) {
              case('polygon'):
                ctx.lineTo(this.mouseX, this.mouseY);
              break;
              case('rectangle'):
                if (sd.length === 1) {
                  ctx.rect(sd[0].x, sd[0].y, this.mouseX - sd[0].x, this.mouseY - sd[0].y);
                }
              break;
              case('circle'):
                if (sd.length === 1) {
                  const r = (this.mouseX - sd[0].x) / 2;
                  const cx = sd[0].x + r;
                  const cy = sd[0].y + r;
                  ctx.arc(cx, cy, Math.abs(r), 0, 2 * Math.PI);
                }
              break;
            }
          }
        }

      region.closePath();
      ctx.closePath();
      ctx.stroke();
    });

    if (this.selectedTool === 'multiselect' && this.multiSelectStart.x > 0 && this.mouseDrag) {
      const stroke = ctx.strokeStyle;
      const lineStyle = ctx.lineWidth;
      ctx.lineWidth = 5;
      ctx.strokeStyle = '#ff0000';
      ctx.setLineDash([6]);
      ctx.strokeRect(
        this.multiSelectStart.x,
        this.multiSelectStart.y,
        this.mouseX - this.multiSelectStart.x,
        this.mouseY - this.multiSelectStart.y);
      ctx.strokeStyle = stroke;
      ctx.lineWidth = lineStyle;
      ctx.setLineDash([]);
    }


    // const region = new Path2D();
    // region.lineTo(30, 90);
    // region.lineTo(110, 20);
    // region.lineTo(240, 130);
    // region.lineTo(60, 130);
    // region.lineTo(190, 20);
    // region.lineTo(270, 90);
    // region.closePath();


    // Fill path
    // ctx.fillStyle = 'green';
    // ctx.fill(region, 'evenodd');

    //ctx.stroke();
  }

  selectTool(toolName: string) {
    if (!this.toolDisabled(toolName) || toolName === 'multiselect') {
      this.selectedTool = this.selectedTool === toolName ? '' : toolName;
    }
  }

  openSectionInputModal () {

    const modalConfig = {
      backdrop: true,
      ignoreBackdropClick: true
    };

    const initialState = {
      csvSectionFile: null,
      viewRef: this.viewRef
    };

    this.bsModalRef = this.modalService
      .show(
        VenueSectionInputModalComponent,
        Object.assign({}, modalConfig, { class: 'modal-lg', initialState }));

    this.bsModalRef.content.submitSections
        .subscribe(
          (result: string[] | {startRange: number, endRange: number, rangePrefix: string, rangeSuffix: string}) => {

            if (Array.isArray(result)) {

              for (let s of result) {

                this.newSectionName = s;
                this.createNewSection()
              }

            } else {

              for (let i = result.startRange; i < result.endRange + 1; i++) {

                this.newSectionName = result.rangePrefix + i + result.rangeSuffix;
                this.createNewSection();
              }
            }
          }
        );
  }

  private _attachEventListeners() {

    this.removeEventListeners.push(this.renderer.listen('document', 'keydown', (e: KeyboardEvent) => {

      if (e.key === 'Escape') {
        this.selectedGroup = '';
        this.venue.venueSections.forEach(s => s.selected = false);
      }
    }));

    this.removeEventListeners.push(this.renderer.listen(this.sectionsRef.nativeElement, 'keydown', (e: KeyboardEvent) => {

      if (e.key === 'ArrowLeft' && this.selectedSection && !this.selectedGroup) {

        e.preventDefault();
        e.stopPropagation();

        const sectionIndex = this.venue.venueSections.indexOf(this.selectedSection);
        const numberOfSections = this.venue.venueSections.length;

        this.selectedSection = this.venue.venueSections[this.modulo(sectionIndex - 1, numberOfSections)]

        for (let s of this.venue.venueSections) {

          s.selected = false;
        }

        this.venue.venueSections[this.modulo(sectionIndex - 1, numberOfSections)].selected = true;
        return;
      }

      if (e.key === 'ArrowRight' && this.selectedSection && !this.selectedGroup) {

        e.preventDefault();
        e.stopPropagation();

        const sectionIndex = this.venue.venueSections.indexOf(this.selectedSection);
        const numberOfSections = this.venue.venueSections.length;

        this.selectedSection = this.venue.venueSections[this.modulo(sectionIndex + 1, numberOfSections)]
        for (let s of this.venue.venueSections) {

          s.selected = false;
        }

        this.venue.venueSections[this.modulo(sectionIndex + 1, numberOfSections)].selected = true;
        return;
      }

    }));
  }

  save() {
    this.checkNameValidity()

    if (!this.venue.imageUrl) {

      this.isImageError = true;
      return;
    }

    if (!this.venueRef || this.isNameError) {
      return;
    }

    this.loading = true;
    this.spinner.show();
    const canvas = this.venueRef.nativeElement;

    // save the width of the canvas this venue was created with,
    // this is used to draw the shapes correctly if the canvas renders
    // at different sizes on different browsers or views
    if (!this.venue.canvasWidth) {
      this.venue.canvasWidth = canvas.width;
    }

    this.venue.name = this.venueName;
    this.imageService
    .commitUploads()
    .pipe(mergeMap(() => {
      if (this.venue.venueId > 0) {
        return this.venueService.update(this.venue);
      } else {
        return this.venueService.create(this.venue);
      }
    }))
    .subscribe( newVenue => {
      this.loading = false;
      this.spinner.hide();
      this.venue.venueId = newVenue.venueId;

      this.dialogService
      .confirm(
        'Venue Saved!',
        'Would you like to continue editing?',
        this.viewRef)
        .then(result => {
          if (!result) {
            this.router.navigate(['/portal/venue']);
          }
        });
    },
      err => {
        this.loading = false;
        this.spinner.hide();
        this.dialogService.alert('Oops something went wrong..', 'We were unable to process your request at this time, please try again in a few moments. Please contact CUE support at support@connectwithcue.com if you continue to experience issues', this.viewRef);
        console.log(err);
      });

  }

  cancel() {
    this.dialogService.confirm('Leaving Venue Editor', `Are you sure you want to leave? Any unsaved changes will be lost forever!`, this.viewRef)
      .then(result => {
        if (result) {
          this.router.navigate(['/portal/venue']);
        }
      });
    }

    ngOnDestroy() {

      for (let remove of this.removeEventListeners) {

        remove();
      }
      this._ngDestroy$.next();
      this._ngDestroy$.complete();
    }

    private modulo(n: number, m: number) {

      // Doing this to support negative n
      return ((n % m) + m) % m;
    }
}

